var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "drag-dialog",
    _vm._g(
      _vm._b(
        {
          staticClass: "reset-dialog",
          attrs: {
            visible: _vm.isShowPassword,
            width: "500px",
            title: _vm.$t("login.resetPassword"),
            "is-show-full": false,
            "is-show-follow": false,
            "is-show-close": _vm.isMustModify,
            "before-close": _vm.handleBeforeClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.isShowPassword = $event
            },
            opened: _vm.opened,
          },
        },
        "drag-dialog",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    ),
    [
      !_vm.isMustModify
        ? _c("p", { staticStyle: { color: "red", "padding-bottom": "10px" } }, [
            _vm._v(_vm._s(_vm.$t("login.modifyTip"))),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-form",
        {
          ref: "resetForm",
          attrs: { model: _vm.form, "label-width": "140px", rules: _vm.rules },
        },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("login.username") + "：",
                prop: "userName",
              },
            },
            [
              _c("el-input", {
                attrs: { maxlength: "30", disabled: "" },
                model: {
                  value: _vm.form.userName,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "userName", $$v)
                  },
                  expression: "form.userName",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("login.oldPassword") + "：",
                prop: "oldPwd",
              },
            },
            [
              _c("el-input", {
                attrs: {
                  type: "password",
                  maxlength: "30",
                  autocomplete: "new-password",
                },
                model: {
                  value: _vm.form.oldPwd,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "oldPwd", $$v)
                  },
                  expression: "form.oldPwd",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              staticClass: "newPwd",
              attrs: {
                label: _vm.$t("login.newPassword") + "：",
                prop: "newPwd",
              },
            },
            [
              _c("el-input", {
                attrs: {
                  type: "password",
                  maxlength: "30",
                  autocomplete: "new-password",
                },
                on: { input: _vm.handleInput },
                model: {
                  value: _vm.form.newPwd,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "newPwd", $$v)
                  },
                  expression: "form.newPwd",
                },
              }),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "strengthTip",
                  style: { color: _vm.passwordStrengthColor },
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.language === "zh"
                        ? _vm.passwordStrengthText
                        : _vm.passwordStrengthTextEn
                    )
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              staticClass: "newPwd",
              attrs: {
                label: _vm.$t("login.confirmPassword") + "：",
                prop: "verifyNewPwd",
              },
            },
            [
              _c("el-input", {
                attrs: {
                  type: "password",
                  maxlength: "30",
                  autocomplete: "new-password",
                },
                model: {
                  value: _vm.form.verifyNewPwd,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "verifyNewPwd", $$v)
                  },
                  expression: "form.verifyNewPwd",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "text-center" },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.submit } },
                [_vm._v(_vm._s(_vm.$t("login.confirmModify")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }